import React from 'react'
import "../Components/DeletePopup.scss"
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

const DeletePopup = ({visible,onHide,onConfirm}) => {
    const footerContent = (
        <div className='popup-buttons'>
            <Button label="Cancel"  onClick={onHide}  className='cancel-btn'/>
            <Button label="Delete"  onClick={onConfirm} autoFocus className="delete-btn"/>
        </div>
    );

    const headerContent = (
    <i className="pi pi-exclamation-circle" style={{ color: '#D92D20',padding:"25px",fontSize:"24px" }}></i>
    )
 
    

    return (
        
        <div className="card flex justify-content-center deleteopopup">
            <Dialog header={headerContent} visible={visible}   onHide={onHide} footer={footerContent}  className="popup-dialogbox" style={{width:"400px",height:"299px"}} appendTo="self">
                <h2 className='popup-title'>Delete Section</h2>
                
                <p className="popup-content">
                    Are you sure you want to delete this Section? This action cannot be undone.
                </p>
            </Dialog>
        </div>
    )
    
}

export default DeletePopup